module.exports = __webpack_public_path__ + "media/images/icons/link_share_yellow-629ac83effbcc2376b8ac16ad1216b7f.svg";